import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiUser, FiLock, FiLogIn } from 'react-icons/fi';
import { GrirApiContext } from './GrirApiContext';
import GRIRApp from './GRIRApp';
import * as grirSksApi from '../../utils/grirSksApi';
import logo from '../../Images/SAVI AI full.png';

const TOKEN_KEY = 'grir_sks_token';

const GRIRLogin = () => {
  const [authed, setAuthed] = useState(() => !!localStorage.getItem(TOKEN_KEY));
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      setError('Please enter username and password.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://saviagent.savictech.com/sks/grir/api/v1/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || 'Invalid credentials');
      }
      const data = await res.json();
      localStorage.setItem(TOKEN_KEY, data.access_token);
      setAuthed(true);
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setAuthed(false);
    setUsername('');
    setPassword('');
    setError('');
  };

  if (authed) {
    return (
      <GrirApiContext.Provider value={{ ...grirSksApi, logout: handleLogout }}>
        <GRIRApp onLogout={handleLogout} />
      </GrirApiContext.Provider>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f0f4ff 0%, #e8f4fd 100%)',
    }}>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        style={{ width: '100%', maxWidth: 400, padding: '0 16px' }}
      >
        <div className="grir-card" style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{
            background: 'linear-gradient(135deg, #0099b0 0%, #005f6e 100%)',
            padding: '32px 32px 24px',
            textAlign: 'center',
          }}>
            <img src={logo} alt="SAVI AI" style={{ height: 22, marginBottom: 16, filter: 'brightness(0) invert(1)' }} />
            <h2 style={{ color: '#fff', fontSize: 18, fontWeight: 700, margin: 0 }}>GRIR Login</h2>
            <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13, margin: '6px 0 0' }}>
              Sign in to access reconciliation
            </p>
          </div>

          <form onSubmit={handleLogin} style={{ padding: '28px 32px 32px' }}>
            <div className="grir-form-group" style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 5 }}>
                <FiUser size={13} /> Username
              </label>
              <input
                className="grir-input"
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                autoFocus
              />
            </div>

            <div className="grir-form-group" style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 5 }}>
                <FiLock size={13} /> Password
              </label>
              <input
                className="grir-input"
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="grir-feedback error" style={{ marginBottom: 16 }}>
                {error}
              </div>
            )}

            <motion.button
              type="submit"
              className="grir-btn primary"
              disabled={loading}
              whileTap={{ scale: 0.97 }}
              style={{ width: '100%', justifyContent: 'center', height: 42 }}
            >
              {loading
                ? <><div className="grir-btn-spinner" /> Signing in…</>
                : <><FiLogIn size={15} /> Sign In</>
              }
            </motion.button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default GRIRLogin;
